import { render, staticRenderFns } from "./GideFooter.vue?vue&type=template&id=c189d048&scoped=true"
import script from "./GideFooter.vue?vue&type=script&lang=js"
export * from "./GideFooter.vue?vue&type=script&lang=js"
import style0 from "./GideFooter.vue?vue&type=style&index=0&id=c189d048&prod&scoped=true&lang=css"
import style1 from "./GideFooter.vue?vue&type=style&index=1&id=c189d048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c189d048",
  null
  
)

export default component.exports